// import visible from '../util/visible';
import $ from 'jquery';
import Vue from 'vue';
import anime from 'animejs';
import Glide from '@glidejs/glide';

let ProgressBar = require('progressbar.js');
let hasSeenValues = false;
// Slider for values
const slider = new Glide('.glide', {
  type: 'slider',
  startAt: 0,
  perView: 3,
  focusAt: 'center',
  gap: 50,
  autoplay: 5000,
  breakpoints: {
    1300: {
      type: 'carousel',
      perView: 2,
    },
    450: {
      perView: 1,
    },
  },
});
export default {
  init() {
    new Vue({
      el: '#jobs',

      data: function () {
        return {
          jobs: [],
          jobActive: false,
          activeJobContent: [],
          apiAll: 'https://' + window.location.host + '/wp-json/wp/v2/jobs/?per_page=100',
          api: 'https://' + window.location.host + '/wp-json/wp/v2/jobs/',
          jobDescriptionTabs: 0,
          jobExpectationsTabs: 0,
          activeStep: 1,
          applicationProgress: 0,
          progressCircle: null,
          inputCount: 0,
          activeFormStage: 1,
          loading: false,
          errors: false,
          emailError: false,
          backspace: false,
          applicationData: {
            first_name: null,
            last_name: null,
            email_address: null,
            telephone: null,
            notice_period: null,
            salary: null,
            job: null,
            job_title: null,
            current_employment_time: null,
            responsibilities: null,
            current_employment_likes: null,
            current_employment_dislikes: null,
            why_work_for_mcg: null,
            alter_ego: null,
            work_examples: null,
            skills: [],
            uploads: [],
          },
          uploadedFiles: [],
          fileCount: null,
          imageUploadError: null,
          ImageUploadStatus: null,
          formSubmitted: false,
          confirmCloseModal: false,
        }
      },


      methods: {
        elementScrolled(elem) {
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();
          var elemTop = $(elem).offset().top;
          return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
        },

        listJobs() {
          // Get list of jobs
          $.ajax({
            url: this.apiAll,
            context: document.body,
          }).done((response) => {
            this.jobs = response;
            // if there is a job param in the URL, load that job
            this.loadJobFromURL();
          });
        },

        resetApplication(){
          // Reset everything
          this.applicationData = {
            first_name: null,
              last_name: null,
              email_address: null,
              telephone: null,
              notice_period: null,
              salary: null,
              job: null,
              job_title: null,
              current_employment_time: null,
              responsibilities: null,
              current_employment_likes: null,
              current_employment_dislikes: null,
              why_work_for_mcg: null,
              alter_ego: null,
              work_examples: null,
              skills: [],
              uploads: [],
          };
          this.uploadedFiles = [];
          this.fileCount = null;
          this.imageUploadError = null;
          this.ImageUploadStatus = null;
          this.formSubmitted = false;
          this.confirmCloseModal = false;
          this.applicationProgress = 0;
          this.progressCircle = null;
          this.inputCount = 0;
          this.activeStep = 1;
          this.activeFormStage= 1;
        },

        viewJob(id) {
          console.log('fire')
          $.ajax({
            url: this.api + id,
            context: document.body,
          }).done((response) => {
            this.activeJobContent = response;
            const jobUrl = '?job=' + this.activeJobContent.slug;
            window.history.pushState(null, null, jobUrl);
            $('html').addClass('no-overflow');
            this.jobActive = true;
            // Generate array of skills
            this.generateSkillsArray();
          });
        },

        closeJob() {
          this.confirmCloseModal = !this.confirmCloseModal;
        },
        confirmClose(){
          this.confirmCloseModal = false;
          $('html').removeClass('no-overflow');
          window.history.replaceState({}, document.title, '/careers'); // Remove any URL params
          this.jobActive = false;
          this.resetApplication();
          this.activeJobContent = null;
        },

        loadApplicationForm() {
          this.$nextTick(() => {
            console.log('loaded');
            // Count how many inputs the user needs to fill in
            this.inputCount = this.inputCount + $('.registration__form input:not([type="radio"]), .registration__form textarea').length;
            this.createProgressCircle();
          })
        },

        loadJobFromURL() {
          // get search parameters
          let searchParams = new URLSearchParams(window.location.search);
          // If job exists
          if (searchParams.has('job')) {
            let param = searchParams.get('job');
            for (let i = 0; i < this.jobs.length; i++) {
              if (this.jobs[i].slug === param) {
                this.viewJob(this.jobs[i].id);
                return;
              }
            }
          }
        },
        keymonitor(key) {
          // look out for backspace presses, so even if the user is over the word count they can backspace
          this.backspace = true;
          if (key == 8 || key == 46) this.backspace = true; return;
        },
        checkWordCount(input) {
          const wordCount = 300;
          let data = this.applicationData[input];
          let words = data.match(/\S+/g).length;
          if (words >= wordCount) {
            if (!this.backspace) {
              // Split the string on the first number of words set in wordCount and then rejoin
              var trimmed = this.applicationData[input].split(/\s+/, wordCount).join(' ');
              // Add a space at the end to make sure more typing creates new words
              this.applicationData[input] = trimmed + ' ';
              $('.count-' + input).text(words + ' / ' + wordCount);
              const xMax = 6;
              anime({
                targets: '.count-' + input,
                color: '#ff2f2f',
                duration: 500,
                translateX: [
                  {
                    value: xMax * -1,
                  },
                  {
                    value: xMax,
                  },
                  {
                    value: xMax / -2,
                  },
                  {
                    value: xMax / 2,
                  },
                  {
                    value: 0,
                  },
                ],
                easing: 'easeInOutSine',
              });
            }
          }
          else {
            $('.count-' + input).css('color', '#22212866')
            $('.count-' + input).text(words + ' / ' + wordCount);
          }
          this.backspace = false;
        },

        generateSkillsArray() {
            this.applicationData.skills = [];
            this.activeJobContent.acf.skills.forEach((data) => {
              this.inputCount = this.inputCount + 1;
              let slug = data.name.replace(/ +/g, '_').replace(/\./g, '-');
              let skill = {
                'skill': data.name,
                'slug': slug,
                'rating': null,
              };
              this.applicationData.skills.push(skill);
            });
        },

        reset() {
          // reset form to initial state
          this.ImageUploadStatus = null;
          this.uploadedFiles = [];
          this.uploadError = null;
        },

        isEmail(email) {
          let regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return regex.test(email);
        },

        isNumber(evt) {
          evt = (evt) ? evt : window.event;
          const charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 43) {
            evt.preventDefault();
          } else {
            return true;
          }
        },

        submitApplication() {
          this.applicationData.job = this.activeJobContent.title.rendered;

          $(':input[required]:hidden').removeAttr('required').addClass('wasrequired');
          $('.wasrequired:visible').removeClass('wasrequired').prop('required', 'required');

          // Validation
          // Reset errors
          $('.has-error').removeClass('has-error');
          $('.job__application__sidebar__stage').attr('data-errors', 'false');
          this.errors = false;
          this.emailError = false;

          // Check inputs and textareas
          $('input:not([type=file]), textarea').each(function () {
            if ($(this).val() === '') {
              this.errors = true;
              $(this).addClass('has-error');
            }
          });

          // Check skills have been entered
          this.applicationData.skills.forEach((skill) => {
            if ($('input[name=' + skill.slug + ']:checked').length === 0) {
              this.errors = true;
              $('input[type="radio"][name="' + skill.slug + '"]').closest('.form__group--skills').addClass('has-error');
            }
          });

          // Uncomment to make uploads field required
          // if (this.applicationData.uploads.length < 1) {
          //   this.errors = true;
          //   $('input[type="file"]').closest('.form__group--skills').addClass('has-error');
          //   $('.dropbox').addClass('has-error');
          // }

          if (!this.isEmail(this.applicationData.email_address)) {
            this.emailError = true
          }

          // Show the user where any errors are
          if (this.errors) {
            $('.job__application__form__section').each(function () {
              if ($(this).find('.has-error').length > 0) {
                let stage = $(this).data('stage');
                $('.job__application__sidebar__stage--' + stage).attr('data-errors', 'true');
              }
            });
          }

          // Submit if no errors
          if (!this.errors && !this.emailError) {
            this.loading = true;
            $.ajax({
              // eslint-disable-next-line
              url: ajax_object.ajax_url,
              type: 'post',
              data: {
                action: 'submit_application',
                data: this.applicationData,
              },
              success: (() => {
                $('#application-form')[0].reset();
                this.formSubmitted = true;
                this.loading = false;
              }),
              errors: (() => {
                this.loading = false;
                alert('There was an error submitting your application');
              }),
            });
          }
        },

        animateProgress(progress) {
          this.progressCircle.animate(progress);  // Value from 0.0 to 1.0
          if (this.applicationProgress !== 0) {
            $('.progressbar-text').addClass('has-value');
          } else {
            $('.progressbar-text').removeClass('has-value');
          }
        },

        createProgressCircle() {
          // Set the progressCircle amount, or create it if it does not exist
          if (this.progressCircle) {
            this.progressCircle.destroy();
          }
          this.progressCircle = new ProgressBar.Circle('#application-progress', {
            easing: 'easeInOut',
            strokeWidth: 20,
            color: '#FE9900',
            trailColor: '#e6e6e6',
            // Set default step function for all animate calls
            step: function (state, circle) {
              var value = Math.round(circle.value() * 100);
              if (value === 0) {
                circle.setText('0');
              } else {
                circle.setText(value);
              }
            },
          });
          if (this.progressCircle) {
            this.animateProgress(this.applicationProgress);
          }
        },

        updateProgress(field) {
          // Target the input by name
          // eslint-disable-next-line
          let input = $('input[name="' + field + '"]');
          let textarea = $('textarea[name="' + field + '"]');
          let modifiedField = null;
          // Get the amount that we should increment by
          let increment = 1 / this.inputCount;

          // If a value has been added for this field, we should increment the form progress
          if (input.length > 0) {
            modifiedField = input;
          } else if (textarea.length > 0) {
            modifiedField = textarea;
          }
          if (modifiedField && this.applicationData[field] !== '') {
            // We double check this field has not already been used (.active),
            // preventing additional form progress being made
            if (!modifiedField.hasClass('active')) {
              this.applicationProgress = this.applicationProgress + increment;
              this.animateProgress(this.applicationProgress);
              // Adds an active class to ensure this progress isn't added again
              modifiedField.addClass('active');
            }
            // If a value is not set, this means the data has been removed
          } else {
            this.applicationProgress = this.applicationProgress - increment;
            this.animateProgress(this.applicationProgress);
            input.removeClass('active');
          }
        },

        uploadFiles() {
          this.ImageUploadStatus = 'saving';
          let $files = $('#file_upload');
          let file_obj = $files.prop('files');
          let form_data = new FormData();
          for (let i = 0; i < file_obj.length; i++) {
            form_data.append('file[]', file_obj[i]);
          }
          form_data.append('action', 'file_upload');
          $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            contentType: false,
            processData: false,
            data: form_data,
            success: (response) => {
              console.log(response);
              if (response.success) {
                $files.val('');
                this.ImageUploadStatus = 'success';
                response.data.files.urls.forEach((url) => {
                  this.applicationData.uploads.push(url)
                });
                response.data.files.files.forEach((file) => {
                  this.uploadedFiles.push(file)
                });
              } else {
                this.ImageUploadStatus = response.data.errors;
              }
            },
          });
        },

        bytesToSize(bytes) {
          var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
          if (bytes === 0) return '0 Byte';
          var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
          return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        },
      },

      mounted() {
        this.reset();


        // Tabs
        $('.careers-tabs .tab_1').addClass('is-active');
        $('.careers-tabs__titles li').on('click touchend', function () {
          var clicked = $(this).data('tab');
          $('.careers-tabs .is-active').removeClass('is-active');
          $('.careers-tabs .' + clicked).addClass('is-active');
          anime({
            targets: '.careers-tabs li.is-active *',
            translateY: [20, 0],
            opacity: [0, 1],
            duration: 1000,
            delay: anime.stagger(100),
            easing: 'easeInOutQuad',
          });
          anime({
            targets: '.careers-tabs__left figure.is-active',
            translateY: [20, 0],
            opacity: [0, 1],
            duration: 1000,
            delay: anime.stagger(100),
            easing: 'easeInOutQuad',
          });
        });

        this.listJobs();

        slider.mount();
        slider.pause();

        // Check for the values coming into view and then play the slider
        $(window).scroll(() => {
          if (this.elementScrolled('.careers-values') && !hasSeenValues) {
            hasSeenValues = true;
            slider.play(); // Play the slider
          }
        });
      },

      computed: {
        jobsAvailable() {
          return this.jobs
        },
      },

      updated() {
      },

    })

  },
};

